import React, { useEffect, useState } from "react";
import { TableCell, Chip } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import apiUser from "../../../api/user";

function RenderTagsCell({
  tags,
  headContact,
  row,
  handleDeleteTag,
  handleOpenDialogTag,
}) {
  const [mappedTags, setMappedTags] = useState([]);

  useEffect(() => {
    const fetchAndMapTags = async () => {
      if (tags && tags.length > 0) {
        try {
          const res = await apiUser.find_and_map_tags_by_arr_id({
            tags_id: tags,
          });
          if (res.status === 200) {
            setMappedTags(res?.data?.data || []);
          } else {
            setMappedTags([]);
          }
        } catch (error) {
          console.error("Error fetching tags:", error);
          setMappedTags([]);
        }
      }
    };

    fetchAndMapTags();
  }, [tags]);

  if (headContact.field_variable === "tag") {
    if (tags && tags.length > 0) {
      if (mappedTags && mappedTags.length > 0) {
        return (
          <TableCell
            align="center"
            sx={{
              maxWidth: 180, // Set the max width
              textOverflow: "ellipsis", // Add ellipsis for long text
            }}
          >
            {mappedTags.map((item) => (
              <Chip
                key={item.id}
                label={item.tag}
                onDelete={() => handleDeleteTag(row, item)}
                sx={{
                  color: "white",
                  backgroundColor: item.color,
                  cursor: "pointer",
                  mt: 1,
                  mr: 0.5,
                }}
              />
            ))}
          </TableCell>
        );
      }
    }

    // If no tags available, render "Add New" button
    return (
      <TableCell align="center">
        <Chip
          onClick={() => handleOpenDialogTag(row)}
          icon={<AddIcon />}
          label="Thêm mới"
          variant="outlined"
          sx={{ border: "1px dashed", cursor: "pointer" }}
        />
      </TableCell>
    );
  }

  return null; // Return null if not matching `headContact.field_variable`
}

export default RenderTagsCell;
